import { render, staticRenderFns } from "./youtube-video.vue?vue&type=template&id=5a33b641&"
import script from "./youtube-video.vue?vue&type=script&lang=js&"
export * from "./youtube-video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a33b641')) {
      api.createRecord('5a33b641', component.options)
    } else {
      api.reload('5a33b641', component.options)
    }
    module.hot.accept("./youtube-video.vue?vue&type=template&id=5a33b641&", function () {
      api.rerender('5a33b641', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DmE6mNkGyxYF/JS/youtube-video.vue"
export default component.exports